import { defineStore } from "pinia";
import { ref } from "vue";

export const useUserStore = defineStore("user", () => {
  let loggedInUser = ref(null);


  const setUser = (user) => {
    loggedInUser.value = user;
  };
  const getUser = () => {
    return loggedInUser.value;
  };

  const getIsAuthenticated = () => {
    return  !!loggedInUser.value;
  };

  const getUserRoles = () => {
    return loggedInUser.value?.groups?.split("^") || [];
  };

  const getUserSub = () => {
    return loggedInUser?.value?.sub;
  };


  return {
    loggedInUser,
    setUser,
    getUser,
    getIsAuthenticated,
    getUserRoles,
    getUserSub,
  };
});
